export interface PasswordRules {
    minLength: boolean;
    hasUppercase: boolean;
    hasLowercase: boolean;
    hasNumberOrSpecial: boolean;
}

export const checkPasswordRules = (password: string): PasswordRules => ({
    minLength: password.length >= 8,
    hasUppercase: /[A-Z]/.test(password),
    hasLowercase: /[a-z]/.test(password),
    hasNumberOrSpecial: /[0-9!@#$%^&*()\-_=+\[\]{};':"\\|,.<>/?`~]/.test(password),
});

export const isPasswordValid = (password: string): boolean =>
    Object.values(checkPasswordRules(password)).every(Boolean);

export const PASSWORD_RULE_LABELS: Record<keyof PasswordRules, string> = {
    minLength: 'Aspoň 8 znakov',
    hasUppercase: 'Aspoň 1 veľké písmeno',
    hasLowercase: 'Aspoň 1 malé písmeno',
    hasNumberOrSpecial: 'Aspoň 1 číslo alebo špeciálny znak',
};
